// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/Roboto/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/Roboto/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/Roboto/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/Roboto/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/workdaybanner-ayla.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/bareclock.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "roboto";
  src: 
    local('Roboto'),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 100 400;
}

@font-face {
  font-family: "roboto";
  src: 
    local('Roboto'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: 500 600;
}

@font-face {
  font-family: "roboto";
  src: 
    local('Roboto'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-weight: 700 800;
}

@font-face {
  font-family: "roboto";
  src: 
    local('Roboto'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-weight: 900;
}

body {
  background-color: rgb(240, 241, 242);
}
.content-container {
  display: flex;
  min-height: calc(100vh - 64px);
  flex-direction: column;
  box-sizing: border-box;

  font-family: roboto, sans-serif;
  color: rgb(51, 51, 51);
  background-color: rgb(240, 241, 242);
}

h1, h2, h3, h4, p {
  margin: 0;
  margin-bottom: 2rem;

  letter-spacing: 0.015rem;
}

h2 {
  font-size: 1.25em;
}

.nav {
  background-color: white;
  width: 100%;
  height: 64px;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,.12);
}

footer {
  text-align: center;
  letter-spacing: 0.02rem;
  font-size: 0.75em;
  color: rgb(73, 73, 73);
}

footer img {
  width: 200px;
  height: 53px;
}

footer a {
  text-decoration: none;
  font-weight: 600;
  color: #393939;
}
footer p {
  margin-inline: 1em;
}

.banner {
  width: 100%;
  height: 192px;

  background-position-y: 15%;
  background-size: cover;
  /*background-image: url("https://wd10.myworkday.com/wday/pex/graphql/images/ubc/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtZXNzYWdlIjoie1wiaWRcIjpcIjVlYjQ0NjA2ZWUyMjAxZWFmNDk0NWQ4MDY1MDE5YjJhXCJ9IiwiaWF0IjoxNzE4NTgyNDAwLCJleHAiOjE3MTg2NzYwMDB9.Bg8jzUOGu1e3TuUFmAeW0NVWq-2TQcv30-nfVfCKg5s");*/
  /*background-image: url('https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Irving_K._Barber_Library.jpg/640px-Irving_K._Barber_Library.jpg');*/
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.home {
  display: flex;
  flex-direction: row;
  max-width: 1344px;
  margin: 2em auto;
  width: 100%;
  padding-inline: 2em;
  box-sizing: inherit;
}

.home > .left {
  width: 80%;
  max-width: 840px;
}

.home > .right {
  flex-grow: 1;
  margin-left: 2em;
}

.date {
  font-size: 1.25rem;
  color: rgb(94, 106, 117);
  margin-top: 0.6em;
}

.home-section {
  margin-bottom: 2rem;
  background-color: white;
  padding-block: 1.5rem;
  padding-inline: 1.5rem;
  border-radius: 1rem;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 2px 4px;
}

.home-section p {
  margin-bottom: 1.5rem;
  color: rgb(94, 106, 117);
  text-align: center;
}

.home-section ul {
  margin: 0;
  padding: 0;

  list-style: none;
}

.home-section ul a {
  display: flex;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5em;
  border-radius: 8px;
  border: none;
  background: none;

  text-align: left;
  text-decoration: none;
  cursor: pointer;
}

.home-section ul a:hover {
  background-color: rgb(223, 226, 230);
}

.home-section ul a:hover .circle {
  background-color: #c6d1df;
}

.home-section ul .app-icon {
  margin-left: 8px;
  position: relative;
  width: 60px;
  height: 68px;
}

.app-icon .circle {
  width: auto;
  height: 50px;
  border-radius: 100%;
  background-color: #E0E8F2;
  aspect-ratio: 1;

  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transition-property: width, height;
  transition-duration: 0.25s;
}
.app-icon:hover .circle{
  height: 57px;
}

.app-icon svg {
  z-index: 10;
  width: auto;
  height: 50%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transition-duration: 1s;
  overflow: visible;
}

.app-icon svg.grad {
  height: 80%;
  top: 75%;
}

.app-icon svg.grad > *{
  display: none;
}

.app-icon:hover svg.grad > *{
  display: block;
}

.app-icon svg.grad > .hat {
  display: block;
}

.app-icon svg.grad .bags, .app-icon svg.grad .tear {
  opacity: 0;
  transition-duration: 1s;
  transition-delay: 1s;
}

.app-icon:hover svg.grad {
  height: 75%;
  top: 50%;
}
/*
.app-icon:hover svg.grad .bags {
  opacity: 1;
}
*/
.app-icon:hover svg.grad .tear {
  animation: cry 5s 2s infinite;
}

@keyframes cry {
  0% {opacity: 0;transform: translateY(0%);}
  5% {opacity: 1;transform: translateY(0%);}
  30% {opacity: 1;}
  80% {opacity: 0;transform: translateY(20%);}
  100% {opacity: 0;}
}

.app-icon svg.rocket {
  width: auto;
  height: 125%;
  position: absolute;
  left: 50%;
  top: 65%;
  transform: translate(-50%, -50%);
  transition-duration: 1s;
}

svg.rocket .fire {
  display: none;
}
.fire-a {
  animation: firing-a 1s infinite;
}
.fire-b {
  animation: firing-b 1s infinite;
}
.fire-c {
  animation: firing-c 1s infinite;
}
svg.rocket.explode {
  /*top: -100px;*/
  animation: spiraling 3s 1s 1 ease-in-out, fall 0.75s 7s ease-in;
}

svg.rocket .star {
  opacity: 0;
  width: 0;
  
}

svg.rocket.explode .star {
  animation: combust 1s 8s ease-in-out;
} 

@keyframes spiraling {
  /*0% {rotate: 180deg}*/
  5% {right: 15%; top:30%; rotate: -180deg; transform-origin: -3px -5px;}
  25% {right: 50%; top:70%; transform-origin: -2px -5px;}
  45% {right: 30%; top:55%; transform-origin: -5px -5px;}
  75% {right: 80%; top:5%; transform-origin: -3px -5px;}
  100% {transform-origin: -2px -5px; rotate: -1980deg;}
}

@keyframes fall {
  5% {left: 25%; right: 75%; top:-50%; rotate: 180deg; height: 350px;}
  100% {left: 25%; right: 75%; top:calc(100% - 100px); rotate: 180deg; height: 350px;}
}

@keyframes combust {
  5% {width: 0; opacity: 0;}
  30% {width: 100%;opacity: 1;}
  100% {width: 0; opacity: 0;}
}

.rocket.explode .fire {
  display: block;
}

#root > .rocket {
  position: absolute;
  left: 55%;
  top: -25%;
  z-index: 10;
  height: 200px;
}

@keyframes firing-a {
  0% {opacity: 0;}
  5% {opacity: 1;}
  25% {opacity: 0;}
  100% {opacity: 0;}
}
@keyframes firing-b {
  0% {opacity: 0;}
  20% {opacity: 0;}
  25% {opacity: 1;}
  40% {opacity: 0;}
  100% {opacity: 0;}
}
@keyframes firing-c {
  0% {opacity: 0;}
  35% {opacity: 0;}
  40% {opacity: 1;}
  80% {opacity: 0;}
  100% {opacity: 0;}
}

.app-icon .coin, .app-icon .wallet-back, .app-icon .wallet-front {
  transition-duration: 1s;
}

.app-icon:hover .coin {
  height: 40%;
  transform: translateY(-75%);
}

.app-icon:hover .wallet-back {
  transform: translateX(2%) rotate(-5deg);
}

.app-icon:hover .wallet-front {
  transform: translateY(5%) scaleX(0.9);
}

.app-icon:hover .link {
  height: 40%;
}

.home-section ul h3 {
  margin: auto 1em;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 700;
  color: rgb(73, 73, 73);
}

.pageheader {
  display: flex;
  width: 100%;
  height: 66.5px;
  background-color: rgb(0, 33, 69);
  color: white;
}

.pageheader h1 {
  margin: auto 1em;
  font-size: 1.5em;
}

.pageheader a {
  padding: 0 0.4em;
  vertical-align: middle;
  color: inherit;
  opacity: 0.9;
}

.pageheader a:hover {
  opacity: 1;
}

.tabmenu {
  background-color: white;
  font-size: 13px;
}

.tabmenu ul {
  list-style: none;
  margin: 0;
}

.tabmenu ul li {
  height: 49px;
  vertical-align: middle;
  display: inline-block;
  line-height: 44px;
  margin-right: 3em;
  border-bottom: 4px solid transparent;
}

.tabmenu ul li a {
  color: inherit;
  text-decoration: none;
}

.tabmenu ul li.selected {
  border-color: #005dba;
}

.section-container {
  margin: 2em 2.5em;
  height: 500px;
  position: relative;
}

.section-box {
  position: absolute;
  min-height: 80px;
  border-radius: 3px;

  box-shadow: 0 1px 3px 0 rgba(10, 22, 29, 0.05);
}

div.section-box {
  padding: 1em;
  background-color: white;
}

.section-box h2, .section-box p {
  margin-bottom: 1rem;
}

.section-box h2 {
  color: #5b6166;
  font-weight: 400;
  font-size: 18px;
}

.section-box p, .section-box table {
  font-size: 13px;
}

.progress {
  width: 30%;
  padding: 1em;
  background-color: white;
  animation: progress-intro 2s 1, progress-idle 1.5s 2s infinite;
}

.progress h3 {
  margin: 0 6em 0 0;

  font-size: 15px;
  line-height: 22px;
  font-weight: 500;
}

.progress .satisfied {
  font-size: 18px;
  color: #58b7df;
  line-height: 22px;
}

.progress .out-of {
  color: dimgray;
  font-size: 12px;
}

.progress .average {
  font-size: 13px;
}

.progress .average span {
  margin-left: 40px;
  animation: flashing-average 0.25s alternate-reverse infinite ease-in-out;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 350px;
}

.progress-flex {
  display: flex;
  margin-top: 2em;
}

.progress-circle {
  aspect-ratio: 1;
  height: 55px;
  width: 55px;

  position: relative;
  background-color: #EEE;
  margin: 0 2em 3em 6em;
  clip-path: circle(48%);
}

.progress-circle-inner {
  position: relative;
  z-index: 100;

  width: 75%;
  border-radius: 100%;
  aspect-ratio: 1;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: white;

  text-align: center;
  color: #58b7df;
  font-size: 1.3em;
}

.progress-circle-inner span {
  transform: translate(-50%,-50%);
  position: absolute;
  top: 50%;
  left: 50%;
}

.progress-circle-filled {
  position: relative;
  top: 0;
  left: 0;

  height: 40px;
  width: 100px;
  bottom: 4.5em;
  transform-origin: top;
  background-color: #58b7df;
  animation: progress-filled-intro 1.25s 3 linear, progress-filled-shake 3s 3.75s infinite alternate ease-in-out;
}

.holds {
  width: 30%;
  padding: 1em;
  left: calc(30% + 3em);
  background-color: white;
  animation: holds-intro 0.5s 1, holds-idle 1.5s 0.5s infinite alternate;
}

.links {
  position: absolute;
  width: 34%;
  right: 0;
}

.links ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.links ul li {
  position: relative;
  margin-bottom: 5px;
  font-size: 13px;
  background-color: white;
}
.links li.section-box {
  padding: 1em 0;
}

.links h2 {
  padding: 5px 20px 10px 20px;
  margin: 0;
}

.links ul li a, .links ul li button {
  display: block;
  background: none;
  padding: 0.75em 20px;
  border: none;
  width: 100%;
  box-sizing: border-box;

  text-align: left;
  font-weight: 500;
  color: inherit;
  text-decoration: none;
  font-size: inherit;
  font-family: inherit;
}
.links ul li a:hover, .links ul li button:hover {
  background-color: #EEE;
  color: inherit;
  cursor: pointer;
}

.records {
  animation: records-intro 3s 1;
}

.records-first {
  animation: records-items 0.5s infinite alternate ease-in-out;
}

.records-second {
  animation: records-items 0.5s 0.1s infinite alternate ease-in-out;
}

.records-third {
  animation: records-items 0.5s 0.2s infinite alternate ease-in-out;
}
.records-fourth {
  animation: records-items 0.5s 0.3s infinite alternate ease-in-out;
}

@keyframes flashing-average {
  0% {color: #470202; letter-spacing: -0.1em; font-size: 40px;}
  100% {color: red; letter-spacing: 0.25em; font-size: 13px;}
}

@keyframes progress-filled-intro {
  0% {transform: rotate(0);}
  25% {transform: rotate(30deg);}
  75% {transform: rotate(-30deg);}
  100% {transform: rotate(0);}
}

@keyframes progress-filled-shake {
  0% {height: 15px; transform: rotate(0);}
  15% {height: 17px; transform: rotate(3deg);}
  30% {transform: rotate(-3deg);}
  50% {height: 14px;transform: rotate(0);}
  80% {height: 20px; transform: rotate(3deg);}
  100% {height: 15px; transform: rotate(-3deg);}
}

@keyframes progress-intro {
  0% {width: 30%; left: -100px; top: 10%; transform: rotate(0);}
  30% {left: 100px; top: 0;}
  60% {left: 0; top: 80%;}
  90% {width: 25%; left: 70%; top: -10px; transform: rotate(360deg);}
  100% {width: 30%; left: 0; top: 0; transform: rotate(360deg);}
}

@keyframes progress-idle {
  0% {top: 0; transform: rotate(0);}
  30% {top: 15px; transform: rotate(3deg);}
  60% {top: 5px;transform: rotate(-3deg);}
  100% {top: 0;transform: rotate(0);}
}

@keyframes holds-intro {
  0% {top: -100px}
  60% {top: 100%}
  100% {top: 0}
}

@keyframes holds-idle {
  0% {top: 0}
  60% {top: 50px}
  100% {top: -50px}
}

@keyframes records-intro {
  0% {top: 100%}
  100% {top: 0}
}

@keyframes records-items {
  0% {left: -1em}
  100% {left: 1em}
}


/* Registration */
.appointments {
  width: 30%;
  height: 30%;
  padding: 1em;
  left: 0;
  background-color: white;
  animation: registration-wait 15s 1, registration-intro 15s 3s 1 ease-out;
}

.appointments div {
  width: 100%;
  overflow: auto;
  height: 70%;
  box-sizing: border-box;
}

.appointments table {
  width: 1000px;
  margin: 1em;
}

.appointment-page{
  max-width: 800px;
  margin: auto;
  position: relative;
}

.section-box th {
  border: 1px solid rgb(212, 212, 212);
  padding: 1em;
  line-height: 2em;
  background-color: #EEE;
  font-weight: 500;
}

.section-box table td {
  padding: 1em;
  border: 1px solid rgb(212, 212, 212);
  text-align: center;
}


@keyframes registration-intro {
  0% {opacity: 0; top: 100%; touch-action: none; pointer-events: none;}
  100% {opacity: 100%; top: 0; touch-action: auto; pointer-events: auto;}
}

@keyframes registration-wait {
  0% {opacity: 0;}
  100% {opacity: 0;}
}

.schedule {
  width: 30%;
  padding: 1em;
  left: calc(30% + 2.5em);
  background-color: white;
  animation: registration-intro 10s 1 ease-out;
}

.schedule ion-icon {
  vertical-align: bottom;
  font-size: 1.25em;
}

.schedule p.met span.not-met {
  display: none;
} 

.schedule p.not-met span.met {
  display: none;
} 

span.not-met ion-icon {
  color: red;
}

span.met ion-icon {
  color: green;
}

.reg-links {
  animation: registration-wait 15s 1, registration-intro 15s 3s 1 ease-out;
}

dialog {
  padding: 0;
  margin-top: 12vh;
  max-width: 1024px;
  min-width: 640px;
  border: none;
  border-radius: 1em;
  overflow: unset;
  h1 {
    border-bottom: 1px solid #dfe2e6;
    padding: 1.2em 2em;
    margin: 0;
    width: 100%;
    box-sizing: border-box;

    color: rgb(51, 51, 51);
    font-size: 1.1em;
  }
  ul {
    list-style: none;
    padding: 0 2em;
  }
  label {
    margin-right: 1em;
    color: #494949;
    font-size: 0.9em;
    font-weight: 600;
  }
  input[type="text"] {
    width: 246px;
    height: 36px;
    padding: 8px 8px 8px 12px;
    box-sizing: border-box;
    border: none;
    background: none;
  }
  input:focus-visible {
    border: none;
  }
}

@keyframes angry {
  0% {background-color: white;}
  10% {background-color: red;}
  100% {background-color: white;}
}

@keyframes shake {
  0% {transform: rotate(0);}
  25% {transform: rotate(10deg);}
  75% {transform: rotate(-10deg);}
  100% {transform: rotate(0);}
}

.options {
  display: none;
  width: 100%;
  max-height: 50vh;
  position: absolute;
  left: -2px;
  overflow: auto;
  overflow-y: scroll;

  background-color: white;
  border: 2px solid #0875e1;
  border-radius: 0 0 4px 4px;
  border-top-width: 1px;
  border-top-color: #a1aab3;
}

.annoying-selector:focus-within .options, .options:focus-within {
  display: block;
}
.annoying-selector {
  height: 100%;
  display: inline-block;
  width: -moz-fit-content;
  width: fit-content;
  position: relative;
  border-radius: 4px;
  border: 2px solid #0875e1;
}

.annoying-selector ul {
  padding: 0;
  width: 100%;
}

.date-options li {
  width: 100%;
}

ul.selected-list {
  padding: 0.35em;
}

.selected-list li {
  width: -moz-fit-content;
  width: fit-content;
  display: inline;
  margin-right: 0.25em;
  padding: 0.1em;
  font-size: 0.8em;
  color: rgb(51, 51, 51);
  background-color: rgb(232, 235, 237);
}

.annoying-selector button {

  padding: 8px 8px 8px 12px;
  box-sizing: border-box;
  width: 100%;
  background: none;
  border:none;
  color: rgb(73, 73, 73);
  text-align: left;
}

.annoying-selector ul button:hover {
  background-color: rgb(230, 235, 237);
  cursor: pointer;
}

.annoying-selector ul button:hover > * {
  cursor: pointer;
}

.annoying-selector button.options-header {
  font-weight: 600;
  font-size: 0.9em;
  border-bottom: 1px solid #a1aab3;
}

button:hover {
  cursor: pointer;
}

.stupid-fucking-modal--buttons {
  margin-top: 5em;
  padding: 0.5em 1.5em;
  border-top: 1px solid #dfe2e6;
  display: flex;
  justify-content: right;
}

.stupid-fucking-modal--buttons button {
  margin: 0.5em;
  border: none;
  border-radius: 2em;
  padding: 1em 0;
  width: 110px;
  text-align: center;
  color: white;
  font-weight: 600;
}
.stupid-fucking-modal--buttons button.ok {
  background-color: orange;
  color: white;
}
.stupid-fucking-modal--buttons button.ok:hover {
  background-color: hsla(34, 100%, 47.5%, 1);
}

.stupid-fucking-modal--buttons button.cancel {
  color: hsla(0, 0%, 20%, 1);
  background: none;
  border: 1px solid;
}
.stupid-fucking-modal--buttons button.cancel:hover {
  color: white;
  background-color: hsla(0, 0%, 20%, 1);
}

.info-bar {
  background-color: white;
  font-size: 13px;
  padding: 0 3em 3em 3em;
}

.info-segment-idk {
  display: flex;
  margin: 1em 0;
}

.info-segment-idk label {
  color: #494949;
  font-size: 1em;
  font-weight: 600;
}

.info-segment-idk ul {
  display: inline-block;
  margin: 0;
  list-style: none;
  padding-left: 1.5em;
}

.info-segment-idk ul li {
  width: -moz-fit-content;
  width: fit-content;
  margin-bottom: 0.5em;
}

.terrible-spreadsheet-mf {
  margin: 2em 0;
  display: flex;
}

.terrible-spreadsheet-mf .filters {
  padding: 1em 2.5em;
  background-color: white;
  box-sizing: border-box;
  width: 300px;
  flex-shrink: 0;
  flex-grow: 0;
  height: -moz-fit-content;
  height: fit-content;
  position: sticky;
  top: 3em;
}

.filters .credit {
  margin-top: 2em;
  font-size: 0.75em;
  font-style: italic;
}

.filters .credit a {
  color: #464646;
}

.filters button {
  background: none;
  border: none;
  display: block;
  margin: 1em 0;
  text-align: left;
  font-size: 0.8em;
  color: #464646;
}

.filters button:hover {
  color: black;
}

.filters h2 {
  color: #333;
  font-weight: 700;
  margin: 1em 0;
  font-size: 1.1em;
}

.terrible-spreadsheet-mf .results {
  margin: 0 2.5em;
  flex-grow: 1;
  min-height: 60vh;
  position: relative;
  padding: 1em 0;
}

.terrible-spreadsheet-mf .results h2 {
  margin-bottom: 1em;
}

.terrible-spreadsheet-mf .results ul {
  padding: 0;
  position: relative;
}

.edge {
  width: 5px;
  aspect-ratio: 1;
  position: absolute;
  background-color: red;
}

.origin {
  width: 5px;
  aspect-ratio: 1;
  position: absolute;
  background-color: lime;
  z-index: 10;
}

.ease-in .comics {
  transition-duration: 2s;
}

.comics > img {
  height: 200px;
}

.comics > div {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-weight: 600;
  color: black;
  font-size: 2em;
  filter: drop-shadow(0 -1px 5px white)
}

.comics {
  padding: 0;
  border-radius: 0;
  border: none;
}

.animating .comics {
  position: absolute;
}

.animating .comics > img {
  height: auto;
}

.sky {
  height: 70vh;
  max-width: 100%;
  margin: 2em;
  position: relative;
  cursor: crosshair;
  overflow-x: clip;
  overflow-y: hidden;
}

.courseBox {
  margin: 1em auto;
  transition-duration: 0.1s;
  padding: 1em;
  max-width: 300px;
  font-family: roboto;
  background-color: white;
  box-shadow: 5px 5px 35px black;
  border-radius: 1em;

  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.movin-now .courseBox {
  position: absolute;
  margin: 0;
}

.courseBox * {
  margin: 0;
}

.projectile {
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 25vw;
  transform: translateX(-50%);
  animation: throw 0.75s 1;
  opacity: 0;

  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

@keyframes throw {
  0% {width: 25vw; opacity: 1;}
  100% {width: 0px; opacity: 1;}
}

.clock {
  margin: 1em 2em;
  width: 230px;
  height: 300px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: cover;
}

.clock .hands {
  height: 66px;
  filter: drop-shadow(0px 3px 5px #000000aa);
  top: 62px;
  position: relative;
  aspect-ratio: 1;
  left: 72px;
}

.clock .seconds, .clock .minutes, .clock .hours{
  width: 45%;
  height: 5px;
  left: calc(50% - 10px);
  top: 50%;
  position: absolute;
  border-radius: 5px;

  transition-duration: 0.25s;
  background: #16283f;
  transform: rotate(-90deg);
  transform-origin: 10px;
}

.clock .seconds {
  width: 45%;
}

.clock .hours {
  width: 40%;
}

#select-course-modal {
  max-width: 90vw;
  width: 650px;
  max-height: 80%;
  overflow: auto;
}

#select-course-modal .flex {
  margin: 1em;
  display: flex;
}

#select-course-modal ul {
  padding: 0;
}

#select-course-modal h2 {
  margin-bottom: 1em;
}

#select-course-modal ul li {
  margin-bottom: 1em;
  color: #5b6166;
}

#select-course-modal ul li.active {
  color: black;
  font-weight: 600;
}

#select-course-modal .flex .left {
  text-align: center;
}

#select-course-modal .flex .right {
  margin-right: 1em;
}

.dayOfWeek {
  margin: 0;
  font-weight: 600;
} 

.clock-container .instruction {
  -webkit-user-select: none;
          user-select: none;
}
#select-course-modal .stupid-fucking-modal--buttons {
  margin-top: 1em;
}

.stupid-fucking-modal--buttons .ok.inactive, .stupid-fucking-modal--buttons .ok.inactive:hover {
  cursor: auto;
  background-color: rgb(205, 205, 205);
}

.mascot {
  --scale: 150px;
  position: fixed;
  width: var(--scale);
  filter: drop-shadow(0 0 10px #00000052);
  bottom: 1em;
  left: 1em;
  z-index: 500;
  transition-duration: 0.5s;
}

.mascot img {
  width: 100%;
  height: auto;
}

.mascot .speechBubble {
  display: none;
  background-color: white;
  width: max-content;
  max-width: 100%;
  padding: 1em;
  border-radius: 1.5em 1.5em 1.5em 0;
  position: absolute;
  bottom: 100%;
  left: calc(100% - 2em);
  font-size: calc(var(--scale) / 10);
}

.mascot.speaking {
  --scale: 200px;
}

.mascot.speaking .speechBubble {
  display: block;
}

nav.nav {
  display: flex;
  .left, .right {
    display: flex;
  }
  .why-tf-are-you-reading-this {
    flex-grow: 1;
  }
  .searcharea {
    position: relative;
    max-width: 526px;
    margin: 0 auto;
    padding: 0.5em;
  }
  .searchdropdown {
    display: none;
  }
  .searcharea:focus-within .searchdropdown, .searchdropdown:hover {
    display: block;
    position: absolute;
    background: white;
    padding: 1.5em;
    padding-top: calc(64px + 1em);
    left: 0;
    right: 0;
    top: 0;
    border-radius: 1em;
    box-shadow: 0px 8px 16px 0 rgba(0, 0, 0, 0.12);
    color: rgb(94, 106, 117);
    font-weight: 600;
    font-size: 0.9em;
  }
  .dysfunctionalSearch {
    position: relative;
    display: flex;
    margin: 0 auto;
    max-width: 526px;
    border-radius: 2em;
    background-color: rgb(240, 241, 242);
    border: 1px solid rgb(206, 211, 217);
    color: rgb(51, 51, 51);
    z-index: 10;
  }
  .dysfunctionalSearch input {
    margin: 0.6em;
    max-width: none;
    width: 100%;
    border: none;
    background: none;
    outline: none;
    line-height: 1.5em;
    font-size: 1em;
    font-weight: 600;
    font-family: roboto;
  }
  .dysfunctionalSearch ion-icon {
    margin: auto 0;
    width: 1em;
    padding-left: 0.75em;
    
    font-size: 1.5em;
  }
  a, button {
    background: none;
    padding: 1em;
    border-radius: 0;
    border: none;
    
    font-weight: 700;
    font-size: 0.85em;
    color: #333d47;
    text-decoration: none;    
    text-transform: uppercase;

    font-family: roboto;
  }
  a.humour-link img {
    width: 2em;
    vertical-align: middle;
  }
  a.humour-link, button {
    border-right: 1px solid #cad4d9;
    transition: background-color 0.5s;
  }
  a.humour-link:hover, button:hover {
    background-color: #e8ebed;
  }
  .home-link {padding: 1.5em; padding-right: 0;}
  button ion-icon {
    font-size: 2em;
    vertical-align: middle;
    padding-bottom: 0.1em;
    padding-inline: 0.1em;
  }
  .right * {
    margin: 1em;
  }
  .right {
    margin-right: 0.5em;
    padding-left: 100px;
  }
  .hotphoto {
    border-radius: 100%;
    aspect-ratio: 1;
    height: 32px;
  }
} 

::placeholder {
  color:#959596;
  opacity: 1; /* Firefox */
} 

.register-button {
  float: right;
  border-radius: 1em;
  padding: 0.25em 2em;
  border: 1px solid;
  background: none;
}

.register-button.inactive {
  color: grey;
  cursor: default;
}

span.pointer {
  position: absolute;
  animation: point 1s infinite ease-in-out;  
  transform: translateX(0);
  margin-left: 0.25em;
}

@keyframes point {
  0% {transform: translateX(0);}
  66% {transform: translateX(50%);}
  100% {transform: translateX(0);}
}

.captcha-check {
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
  margin: 1em 0;
  padding: 1em 0.5em;
  background: #f9f9f9;
  border: 1px solid #dbdcdb;
  border-radius: 3px;
  float: right;
  box-shadow: 0 2px 5px #0000000d;
  label {
    padding-inline: 0.5em;
  }
}

.spinner {
  display: none;
  font-size: 1.5em;
  position: absolute;
  left: 0.5em;
  color: #408def;
  animation: spin 0.5s infinite ease-out;
  top: 0.65em;
  transform: translate(-50%, 0);
}

@keyframes spin {
  0% {transform: rotate(0);}
  100% {transform: rotate(360deg);}
}
#silly-captcha {
  min-width: unset;
  border-radius: 0;
  margin-block: auto;
  max-height: 80%;
  overflow: auto;
}
.captcha-header {
  margin: 0.5em;
  padding: 1.5em 2em;
  background-color: #408def;
  color: white;
  span {
    display: block;
    margin: 0.25em 0;
    font-size: 1.5em;
    font-weight: 700;
  }
}

.captcha-box {
  max-width: 446px;
}
.captcha-box table {
  width: calc(100% - 1em);
  margin: 0.5em;
  display: flex;
  flex-direction: column;
  aspect-ratio: 1;
}

.captcha-box p.credit {
  margin: 1em;
  font-style: italic;
  font-size: 0.6em;
  margin-bottom: 0;
}

.correct .captcha-box table td, .correct .captcha-bottom button {
  background-color: #38ce64;
}

.correct .captcha-box table td {
  border-color: #38ce64;
}

.wrong .captcha-box table td, .wrong .captcha-bottom button {
  background-color: #ef4040;
}

.wrong .captcha-box table td {
  border-color: #ef4040;
}


.wrong .captcha-bottom button {
  transition-duration: 0.1s;
  animation: 0.1s shake infinite;
}

.wrong .captcha-bottom button .wrong, .correct .captcha-bottom button .correct {
  display: block;
}

.wrong .captcha-bottom button .state, .correct .captcha-bottom button .state {
  display: none;
}

.captcha-box table td {
  border: 1px solid rgb(212, 212, 212);
  padding: 0;
  text-align: center;
  background-color: #408def;
  box-sizing: border-box;
  flex-grow: 1;
}
.captcha-box table tr {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
}

.captcha-box table td.selected button {
  width: calc(100% - 2em);
  height: calc(100% - 2em);
  top: 1em;
}
.captcha-box table td button {
  border: none;
  background: white;
  
  padding: 1em;
  top: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  font-weight: 600;
  color: #333;
  position: relative;
  transition-duration: 0.75s;
}

.captcha-box table td button mark {
  background-color: rgba(255, 255, 255, 0.8);
  color: #333;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.captcha-bottom {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
}

.captcha-bottom p {
  margin: 0.5em;
  padding: 0.5em 1em;
}

.captcha-bottom button .wrong, .captcha-bottom button .correct {
  display: none;
}

.bold {
  font-weight: 800;
}

.bold .hideonbold {
  display: none;
}

.captcha-bottom button {
  background-color: #408def;
  margin: 0.5em;
  padding: 0.5em 1em;
  border-radius: 3px;
  border: none;

  color: white;
  font-weight: 600;
}

.timetable {
  width: 1000px;
  max-width: 100%;
  overflow: clip;
  position: relative;
  height: 500px;
  margin: auto;
  border-radius: 1em;
  filter: drop-shadow(0 2px 5px #00000036);
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: end;
}

.timetable p {
  -webkit-user-select: none;
          user-select: none;
}

.courseCard {
  background-color: #e6ebed;
  padding: 0.5em;
  border-radius: 0.5em;
}

.timetable svg {
  margin: 1em auto;
}
.timetable path {
  fill: transparent;
}
.timetable text {
  font-size: 2.84em;
  font-weight: 900;
  fill: #f29110;
}

.ezekiel {
  left: 0;
  right: 0;
  position: absolute;
  top: 0;
  bottom: 0;
}

.surrounding {
  min-width: 1000px;
  height: auto;
}

.confetti {
  width: 50px;
  height: 10px;
  background-color: red;
  
  z-index: 500;
}

.confetti.blue {
  background-color: #005CB9;
}

.confetti.gold {
  background-color: #F38B00;
}

.confetti.white {
  background-color: white;
}


#confettitwall {
  position: fixed;
  top: 64px;
}

.hooray footer a {
  z-index: 600;
  position: relative;
}

.timetable p {
  margin-inline: 1em;
  margin-bottom: 1em;
  z-index: 10;
}

.timetable a {
  color: #0071c9;
  text-decoration: none;
  border-bottom: 1px solid;
}

.jerkday {
  font-size: 2em;
  font-weight: 600;
  color: purple;
}

.workedtheday {
  width: 500px;
}

.me {
  width: 600px;
}

.finances {
  display: flex;
  gap: 1em;
  flex-wrap: wrap;
}
.finances .section-box {
  position: relative;
  height: -moz-fit-content;
  height: fit-content;
  min-height: 0;
}

.finances .section-box h2, .finances .section-box a {
  font-weight: 400;
  color: #393939;
  text-decoration: none;
}
.finances .section-box h2 {
  margin: 0.5em;
}

.finances .section-box a:hover {
  text-decoration: underline;
}

.nowrap {
  white-space: nowrap;
}

@media only screen and (min-width: 600px) {
  .only-mobile {
    display: none;
  }
  .only-desktop {
    display: block;
  }
}

@media only screen and (max-width: 600px) {
  .only-mobile {
    display: block;
  }
  .only-desktop {
    display: none;
  }
  .mascot {
    width: calc(var(--scale) / 2);
    bottom: 3em;
  }
  .mascot .speechBubble {
    left: 1em;
    max-width: 200%;
  }
  .home {
    flex-direction: column;
    flex-flow: column-reverse;
  }
  .home .left, .home .right {
    margin:0;
    width: 100%;
  }
  nav.nav .right {
    padding-left: 0;
  }
  .hide-on-mobile {
    display: none;
  }
  .section-container {
    margin-inline: 1em;
    height: auto;
  }
  .appointments, .appointment-page {
    transform: none;
    overflow: auto;
  }
  .section-box {
    margin-block: 2em;
    position: relative;
    left: 0;
    width: calc(100% - 2em) !important;
  }
  .register-button {
    float: none;
  }
  .holds {
    margin-block: 3em;
  }
  .links {
    width: 100%;
    left: 0.5em;
    position: relative;
  }
  dialog {
    max-width: calc(100% - 2em);
    min-width: 0;
    margin-inline: 1em;
  }
  .terrible-spreadsheet-mf {
    flex-direction: column;
  }
  .terrible-spreadsheet-mf .filters {
    position: static;
    width: 100%;
  }
  .comics > img {
    max-width: 100%;
    width: 100%;
    height: auto;
  }
  #select-course-modal .flex {
    flex-direction: column;
  }
  .clock {
    margin-inline: auto;
    height: 200px;
  }
  nav.nav .dysfunctionalSearch {
    background: none;
    border: none;
    justify-content: right;
  }
  nav.nav .dysfunctionalSearch ion-icon {
    position: absolute;
    top: 0.5em;
  }
  nav.nav .dysfunctionalSearch input {
    width: 2em;
    opacity: 0;
  }
  input[type="text"] {
    font-size: 16px;
  }
  .annoying-selector .options {
    display: block;
  }
  .annoying-selector {
    width: 100%;
    height: 200px;
  }
  .annoying-selector input[type="text"] {
    display: none;
  }
  .options {
    max-height: 200px;
  }
  #stupid-fucking-modal {
    width: 100%;
  }
  .finalheader {
    font-size: 0.75em;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB;;2CAE0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB;;2CAEyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB;;2CAEuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB;;2CAEwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,sBAAsB;;EAEtB,+BAA+B;EAC/B,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,mBAAmB;;EAEnB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;;EAEb,0BAA0B;EAC1B,sBAAsB;EACtB,iSAAiS;EACjS,sJAAsJ;EACtJ,yDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;;EAEV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;;EAEhB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;;EAEf,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,QAAQ;AACV;AACA;;;;CAIC;AACD;EACE,6BAA6B;AAC/B;;AAEA;EACE,IAAI,UAAU,CAAC,yBAAyB,CAAC;EACzC,IAAI,UAAU,CAAC,yBAAyB,CAAC;EACzC,KAAK,UAAU,CAAC;EAChB,KAAK,UAAU,CAAC,0BAA0B,CAAC;EAC3C,MAAM,UAAU,CAAC;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,+DAA+D;AACjE;;AAEA;EACE,UAAU;EACV,QAAQ;;AAEV;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,IAAI,UAAU,EAAE,OAAO,EAAE,eAAe,EAAE,2BAA2B,CAAC;EACtE,KAAK,UAAU,EAAE,OAAO,EAAE,2BAA2B,CAAC;EACtD,KAAK,UAAU,EAAE,OAAO,EAAE,2BAA2B,CAAC;EACtD,KAAK,UAAU,EAAE,MAAM,EAAE,2BAA2B,CAAC;EACrD,MAAM,2BAA2B,EAAE,gBAAgB,CAAC;AACtD;;AAEA;EACE,IAAI,SAAS,EAAE,UAAU,EAAE,QAAQ,EAAE,cAAc,EAAE,aAAa,CAAC;EACnE,MAAM,SAAS,EAAE,UAAU,EAAE,sBAAsB,EAAE,cAAc,EAAE,aAAa,CAAC;AACrF;;AAEA;EACE,IAAI,QAAQ,EAAE,UAAU,CAAC;EACzB,KAAK,WAAW,CAAC,UAAU,CAAC;EAC5B,MAAM,QAAQ,EAAE,UAAU,CAAC;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,IAAI,UAAU,CAAC;EACf,IAAI,UAAU,CAAC;EACf,KAAK,UAAU,CAAC;EAChB,MAAM,UAAU,CAAC;AACnB;AACA;EACE,IAAI,UAAU,CAAC;EACf,KAAK,UAAU,CAAC;EAChB,KAAK,UAAU,CAAC;EAChB,KAAK,UAAU,CAAC;EAChB,MAAM,UAAU,CAAC;AACnB;AACA;EACE,IAAI,UAAU,CAAC;EACf,KAAK,UAAU,CAAC;EAChB,KAAK,UAAU,CAAC;EAChB,KAAK,UAAU,CAAC;EAChB,MAAM,UAAU,CAAC;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;EACd,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;;EAElB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,8DAA8D;AAChE;;AAEA;EACE,iBAAiB;;EAEjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,wEAAwE;EACxE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;;EAEX,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;;EAEZ,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,uBAAuB;;EAEvB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;;EAEP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,8GAA8G;AAChH;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,sEAAsE;AACxE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,sBAAsB;;EAEtB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,iEAAiE;AACnE;AACA;EACE,iEAAiE;AACnE;;AAEA;EACE,IAAI,cAAc,EAAE,sBAAsB,EAAE,eAAe,CAAC;EAC5D,MAAM,UAAU,EAAE,sBAAsB,EAAE,eAAe,CAAC;AAC5D;;AAEA;EACE,IAAI,oBAAoB,CAAC;EACzB,KAAK,wBAAwB,CAAC;EAC9B,KAAK,yBAAyB,CAAC;EAC/B,MAAM,oBAAoB,CAAC;AAC7B;;AAEA;EACE,IAAI,YAAY,EAAE,oBAAoB,CAAC;EACvC,KAAK,YAAY,EAAE,uBAAuB,CAAC;EAC3C,KAAK,wBAAwB,CAAC;EAC9B,KAAK,YAAY,CAAC,oBAAoB,CAAC;EACvC,KAAK,YAAY,EAAE,uBAAuB,CAAC;EAC3C,MAAM,YAAY,EAAE,wBAAwB,CAAC;AAC/C;;AAEA;EACE,IAAI,UAAU,EAAE,YAAY,EAAE,QAAQ,EAAE,oBAAoB,CAAC;EAC7D,KAAK,WAAW,EAAE,MAAM,CAAC;EACzB,KAAK,OAAO,EAAE,QAAQ,CAAC;EACvB,KAAK,UAAU,EAAE,SAAS,EAAE,UAAU,EAAE,yBAAyB,CAAC;EAClE,MAAM,UAAU,EAAE,OAAO,EAAE,MAAM,EAAE,yBAAyB,CAAC;AAC/D;;AAEA;EACE,IAAI,MAAM,EAAE,oBAAoB,CAAC;EACjC,KAAK,SAAS,EAAE,uBAAuB,CAAC;EACxC,KAAK,QAAQ,CAAC,wBAAwB,CAAC;EACvC,MAAM,MAAM,CAAC,oBAAoB,CAAC;AACpC;;AAEA;EACE,IAAI,WAAW;EACf,KAAK,SAAS;EACd,MAAM,MAAM;AACd;;AAEA;EACE,IAAI,MAAM;EACV,KAAK,SAAS;EACd,MAAM,UAAU;AAClB;;AAEA;EACE,IAAI,SAAS;EACb,MAAM,MAAM;AACd;;AAEA;EACE,IAAI,UAAU;EACd,MAAM,SAAS;AACjB;;;AAGA,iBAAiB;AACjB;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,OAAO;EACP,uBAAuB;EACvB,wEAAwE;AAC1E;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;AACpB;;;AAGA;EACE,IAAI,UAAU,EAAE,SAAS,EAAE,kBAAkB,EAAE,oBAAoB,CAAC;EACpE,MAAM,aAAa,EAAE,MAAM,EAAE,kBAAkB,EAAE,oBAAoB,CAAC;AACxE;;AAEA;EACE,IAAI,UAAU,CAAC;EACf,MAAM,UAAU,CAAC;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf;IACE,gCAAgC;IAChC,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,sBAAsB;;IAEtB,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,IAAI,uBAAuB,CAAC;EAC5B,KAAK,qBAAqB,CAAC;EAC3B,MAAM,uBAAuB,CAAC;AAChC;;AAEA;EACE,IAAI,oBAAoB,CAAC;EACzB,KAAK,wBAAwB,CAAC;EAC9B,KAAK,yBAAyB,CAAC;EAC/B,MAAM,oBAAoB,CAAC;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,kBAAkB;;EAElB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,wBAAmB;EAAnB,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd;AACF;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;;EAElB,yBAAyB,EAAE,WAAW,EACf,oBAAoB;EAC3C,iBAAiB,EAAE,oBAAoB;AACzC;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,wBAAwB;EACxB,UAAU;;EAEV,yBAAyB,EAAE,WAAW,EACf,oBAAoB;EAC3C,iBAAiB,EAAE,oBAAoB;AACzC;;AAEA;EACE,IAAI,WAAW,EAAE,UAAU,CAAC;EAC5B,MAAM,UAAU,EAAE,UAAU,CAAC;AAC/B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,yDAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,0CAA0C;EAC1C,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;;EAElB,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,uCAAuC;EACvC,WAAW;EACX,SAAS;EACT,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,6BAA6B;IAC7B,OAAO;IACP,QAAQ;IACR,MAAM;IACN,kBAAkB;IAClB,8CAA8C;IAC9C,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;IACpC,oCAAoC;IACpC,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,aAAa;IACb,eAAe;IACf,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,UAAU;IACV,oBAAoB;;IAEpB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,YAAY;;IAEZ,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,yBAAyB;;IAEzB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,+BAA+B;IAC/B,iCAAiC;EACnC;EACA;IACE,yBAAyB;EAC3B;EACA,YAAY,cAAc,EAAE,gBAAgB,CAAC;EAC7C;IACE,cAAc;IACd,sBAAsB;IACtB,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,YAAY;EACd;AACF;;AAKA;EACE,aAAa;EACb,UAAU,EAAE,YAAY;AAC1B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,IAAI,wBAAwB,CAAC;EAC7B,KAAK,0BAA0B,CAAC;EAChC,MAAM,wBAAwB,CAAC;AACjC;;AAEA;EACE,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,sCAAsC;EACtC,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,IAAI,oBAAoB,CAAC;EACzB,MAAM,yBAAyB,CAAC;AAClC;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,iBAAiB;;EAEjB,YAAY;EACZ,MAAM;EACN,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;;EAEZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,MAAM;EACN,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;;EAErB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;;AAGA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,wBAAmB;EAAnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,6BAA6B;IAC7B,WAAW;EACb;EACA;IACE,SAAS;IACT,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;IACP,kCAAkC;EACpC;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["@font-face {\n  font-family: \"roboto\";\n  src: \n    local('Roboto'),\n    url('/public/Roboto/Roboto-Regular.ttf');\n  font-weight: 100 400;\n}\n\n@font-face {\n  font-family: \"roboto\";\n  src: \n    local('Roboto'),\n    url('/public/Roboto/Roboto-Medium.ttf');\n  font-weight: 500 600;\n}\n\n@font-face {\n  font-family: \"roboto\";\n  src: \n    local('Roboto'),\n    url('/public/Roboto/Roboto-Bold.ttf');\n  font-weight: 700 800;\n}\n\n@font-face {\n  font-family: \"roboto\";\n  src: \n    local('Roboto'),\n    url('/public/Roboto/Roboto-Black.ttf');\n  font-weight: 900;\n}\n\nbody {\n  background-color: rgb(240, 241, 242);\n}\n.content-container {\n  display: flex;\n  min-height: calc(100vh - 64px);\n  flex-direction: column;\n  box-sizing: border-box;\n\n  font-family: roboto, sans-serif;\n  color: rgb(51, 51, 51);\n  background-color: rgb(240, 241, 242);\n}\n\nh1, h2, h3, h4, p {\n  margin: 0;\n  margin-bottom: 2rem;\n\n  letter-spacing: 0.015rem;\n}\n\nh2 {\n  font-size: 1.25em;\n}\n\n.nav {\n  background-color: white;\n  width: 100%;\n  height: 64px;\n  box-shadow: 0 2px 4px 0 rgba(0,0,0,.12);\n}\n\nfooter {\n  text-align: center;\n  letter-spacing: 0.02rem;\n  font-size: 0.75em;\n  color: rgb(73, 73, 73);\n}\n\nfooter img {\n  width: 200px;\n  height: 53px;\n}\n\nfooter a {\n  text-decoration: none;\n  font-weight: 600;\n  color: #393939;\n}\nfooter p {\n  margin-inline: 1em;\n}\n\n.banner {\n  width: 100%;\n  height: 192px;\n\n  background-position-y: 15%;\n  background-size: cover;\n  /*background-image: url(\"https://wd10.myworkday.com/wday/pex/graphql/images/ubc/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtZXNzYWdlIjoie1wiaWRcIjpcIjVlYjQ0NjA2ZWUyMjAxZWFmNDk0NWQ4MDY1MDE5YjJhXCJ9IiwiaWF0IjoxNzE4NTgyNDAwLCJleHAiOjE3MTg2NzYwMDB9.Bg8jzUOGu1e3TuUFmAeW0NVWq-2TQcv30-nfVfCKg5s\");*/\n  /*background-image: url('https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Irving_K._Barber_Library.jpg/640px-Irving_K._Barber_Library.jpg');*/\n  background-image: url('/public/workdaybanner-ayla.png');\n}\n\n.home {\n  display: flex;\n  flex-direction: row;\n  max-width: 1344px;\n  margin: 2em auto;\n  width: 100%;\n  padding-inline: 2em;\n  box-sizing: inherit;\n}\n\n.home > .left {\n  width: 80%;\n  max-width: 840px;\n}\n\n.home > .right {\n  flex-grow: 1;\n  margin-left: 2em;\n}\n\n.date {\n  font-size: 1.25rem;\n  color: rgb(94, 106, 117);\n  margin-top: 0.6em;\n}\n\n.home-section {\n  margin-bottom: 2rem;\n  background-color: white;\n  padding-block: 1.5rem;\n  padding-inline: 1.5rem;\n  border-radius: 1rem;\n  box-shadow: rgba(0, 0, 0, 0.08) 0px 2px 4px;\n}\n\n.home-section p {\n  margin-bottom: 1.5rem;\n  color: rgb(94, 106, 117);\n  text-align: center;\n}\n\n.home-section ul {\n  margin: 0;\n  padding: 0;\n\n  list-style: none;\n}\n\n.home-section ul a {\n  display: flex;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5em;\n  border-radius: 8px;\n  border: none;\n  background: none;\n\n  text-align: left;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.home-section ul a:hover {\n  background-color: rgb(223, 226, 230);\n}\n\n.home-section ul a:hover .circle {\n  background-color: #c6d1df;\n}\n\n.home-section ul .app-icon {\n  margin-left: 8px;\n  position: relative;\n  width: 60px;\n  height: 68px;\n}\n\n.app-icon .circle {\n  width: auto;\n  height: 50px;\n  border-radius: 100%;\n  background-color: #E0E8F2;\n  aspect-ratio: 1;\n\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transition-property: width, height;\n  transition-duration: 0.25s;\n}\n.app-icon:hover .circle{\n  height: 57px;\n}\n\n.app-icon svg {\n  z-index: 10;\n  width: auto;\n  height: 50%;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transition-duration: 1s;\n  overflow: visible;\n}\n\n.app-icon svg.grad {\n  height: 80%;\n  top: 75%;\n}\n\n.app-icon svg.grad > *{\n  display: none;\n}\n\n.app-icon:hover svg.grad > *{\n  display: block;\n}\n\n.app-icon svg.grad > .hat {\n  display: block;\n}\n\n.app-icon svg.grad .bags, .app-icon svg.grad .tear {\n  opacity: 0;\n  transition-duration: 1s;\n  transition-delay: 1s;\n}\n\n.app-icon:hover svg.grad {\n  height: 75%;\n  top: 50%;\n}\n/*\n.app-icon:hover svg.grad .bags {\n  opacity: 1;\n}\n*/\n.app-icon:hover svg.grad .tear {\n  animation: cry 5s 2s infinite;\n}\n\n@keyframes cry {\n  0% {opacity: 0;transform: translateY(0%);}\n  5% {opacity: 1;transform: translateY(0%);}\n  30% {opacity: 1;}\n  80% {opacity: 0;transform: translateY(20%);}\n  100% {opacity: 0;}\n}\n\n.app-icon svg.rocket {\n  width: auto;\n  height: 125%;\n  position: absolute;\n  left: 50%;\n  top: 65%;\n  transform: translate(-50%, -50%);\n  transition-duration: 1s;\n}\n\nsvg.rocket .fire {\n  display: none;\n}\n.fire-a {\n  animation: firing-a 1s infinite;\n}\n.fire-b {\n  animation: firing-b 1s infinite;\n}\n.fire-c {\n  animation: firing-c 1s infinite;\n}\nsvg.rocket.explode {\n  /*top: -100px;*/\n  animation: spiraling 3s 1s 1 ease-in-out, fall 0.75s 7s ease-in;\n}\n\nsvg.rocket .star {\n  opacity: 0;\n  width: 0;\n  \n}\n\nsvg.rocket.explode .star {\n  animation: combust 1s 8s ease-in-out;\n} \n\n@keyframes spiraling {\n  /*0% {rotate: 180deg}*/\n  5% {right: 15%; top:30%; rotate: -180deg; transform-origin: -3px -5px;}\n  25% {right: 50%; top:70%; transform-origin: -2px -5px;}\n  45% {right: 30%; top:55%; transform-origin: -5px -5px;}\n  75% {right: 80%; top:5%; transform-origin: -3px -5px;}\n  100% {transform-origin: -2px -5px; rotate: -1980deg;}\n}\n\n@keyframes fall {\n  5% {left: 25%; right: 75%; top:-50%; rotate: 180deg; height: 350px;}\n  100% {left: 25%; right: 75%; top:calc(100% - 100px); rotate: 180deg; height: 350px;}\n}\n\n@keyframes combust {\n  5% {width: 0; opacity: 0;}\n  30% {width: 100%;opacity: 1;}\n  100% {width: 0; opacity: 0;}\n}\n\n.rocket.explode .fire {\n  display: block;\n}\n\n#root > .rocket {\n  position: absolute;\n  left: 55%;\n  top: -25%;\n  z-index: 10;\n  height: 200px;\n}\n\n@keyframes firing-a {\n  0% {opacity: 0;}\n  5% {opacity: 1;}\n  25% {opacity: 0;}\n  100% {opacity: 0;}\n}\n@keyframes firing-b {\n  0% {opacity: 0;}\n  20% {opacity: 0;}\n  25% {opacity: 1;}\n  40% {opacity: 0;}\n  100% {opacity: 0;}\n}\n@keyframes firing-c {\n  0% {opacity: 0;}\n  35% {opacity: 0;}\n  40% {opacity: 1;}\n  80% {opacity: 0;}\n  100% {opacity: 0;}\n}\n\n.app-icon .coin, .app-icon .wallet-back, .app-icon .wallet-front {\n  transition-duration: 1s;\n}\n\n.app-icon:hover .coin {\n  height: 40%;\n  transform: translateY(-75%);\n}\n\n.app-icon:hover .wallet-back {\n  transform: translateX(2%) rotate(-5deg);\n}\n\n.app-icon:hover .wallet-front {\n  transform: translateY(5%) scaleX(0.9);\n}\n\n.app-icon:hover .link {\n  height: 40%;\n}\n\n.home-section ul h3 {\n  margin: auto 1em;\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n  font-weight: 700;\n  color: rgb(73, 73, 73);\n}\n\n.pageheader {\n  display: flex;\n  width: 100%;\n  height: 66.5px;\n  background-color: rgb(0, 33, 69);\n  color: white;\n}\n\n.pageheader h1 {\n  margin: auto 1em;\n  font-size: 1.5em;\n}\n\n.pageheader a {\n  padding: 0 0.4em;\n  vertical-align: middle;\n  color: inherit;\n  opacity: 0.9;\n}\n\n.pageheader a:hover {\n  opacity: 1;\n}\n\n.tabmenu {\n  background-color: white;\n  font-size: 13px;\n}\n\n.tabmenu ul {\n  list-style: none;\n  margin: 0;\n}\n\n.tabmenu ul li {\n  height: 49px;\n  vertical-align: middle;\n  display: inline-block;\n  line-height: 44px;\n  margin-right: 3em;\n  border-bottom: 4px solid transparent;\n}\n\n.tabmenu ul li a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.tabmenu ul li.selected {\n  border-color: #005dba;\n}\n\n.section-container {\n  margin: 2em 2.5em;\n  height: 500px;\n  position: relative;\n}\n\n.section-box {\n  position: absolute;\n  min-height: 80px;\n  border-radius: 3px;\n\n  box-shadow: 0 1px 3px 0 rgba(10, 22, 29, 0.05);\n}\n\ndiv.section-box {\n  padding: 1em;\n  background-color: white;\n}\n\n.section-box h2, .section-box p {\n  margin-bottom: 1rem;\n}\n\n.section-box h2 {\n  color: #5b6166;\n  font-weight: 400;\n  font-size: 18px;\n}\n\n.section-box p, .section-box table {\n  font-size: 13px;\n}\n\n.progress {\n  width: 30%;\n  padding: 1em;\n  background-color: white;\n  animation: progress-intro 2s 1, progress-idle 1.5s 2s infinite;\n}\n\n.progress h3 {\n  margin: 0 6em 0 0;\n\n  font-size: 15px;\n  line-height: 22px;\n  font-weight: 500;\n}\n\n.progress .satisfied {\n  font-size: 18px;\n  color: #58b7df;\n  line-height: 22px;\n}\n\n.progress .out-of {\n  color: dimgray;\n  font-size: 12px;\n}\n\n.progress .average {\n  font-size: 13px;\n}\n\n.progress .average span {\n  margin-left: 40px;\n  animation: flashing-average 0.25s alternate-reverse infinite ease-in-out;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 350px;\n}\n\n.progress-flex {\n  display: flex;\n  margin-top: 2em;\n}\n\n.progress-circle {\n  aspect-ratio: 1;\n  height: 55px;\n  width: 55px;\n\n  position: relative;\n  background-color: #EEE;\n  margin: 0 2em 3em 6em;\n  clip-path: circle(48%);\n}\n\n.progress-circle-inner {\n  position: relative;\n  z-index: 100;\n\n  width: 75%;\n  border-radius: 100%;\n  aspect-ratio: 1;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n\n  text-align: center;\n  color: #58b7df;\n  font-size: 1.3em;\n}\n\n.progress-circle-inner span {\n  transform: translate(-50%,-50%);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n\n.progress-circle-filled {\n  position: relative;\n  top: 0;\n  left: 0;\n\n  height: 40px;\n  width: 100px;\n  bottom: 4.5em;\n  transform-origin: top;\n  background-color: #58b7df;\n  animation: progress-filled-intro 1.25s 3 linear, progress-filled-shake 3s 3.75s infinite alternate ease-in-out;\n}\n\n.holds {\n  width: 30%;\n  padding: 1em;\n  left: calc(30% + 3em);\n  background-color: white;\n  animation: holds-intro 0.5s 1, holds-idle 1.5s 0.5s infinite alternate;\n}\n\n.links {\n  position: absolute;\n  width: 34%;\n  right: 0;\n}\n\n.links ul {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.links ul li {\n  position: relative;\n  margin-bottom: 5px;\n  font-size: 13px;\n  background-color: white;\n}\n.links li.section-box {\n  padding: 1em 0;\n}\n\n.links h2 {\n  padding: 5px 20px 10px 20px;\n  margin: 0;\n}\n\n.links ul li a, .links ul li button {\n  display: block;\n  background: none;\n  padding: 0.75em 20px;\n  border: none;\n  width: 100%;\n  box-sizing: border-box;\n\n  text-align: left;\n  font-weight: 500;\n  color: inherit;\n  text-decoration: none;\n  font-size: inherit;\n  font-family: inherit;\n}\n.links ul li a:hover, .links ul li button:hover {\n  background-color: #EEE;\n  color: inherit;\n  cursor: pointer;\n}\n\n.records {\n  animation: records-intro 3s 1;\n}\n\n.records-first {\n  animation: records-items 0.5s infinite alternate ease-in-out;\n}\n\n.records-second {\n  animation: records-items 0.5s 0.1s infinite alternate ease-in-out;\n}\n\n.records-third {\n  animation: records-items 0.5s 0.2s infinite alternate ease-in-out;\n}\n.records-fourth {\n  animation: records-items 0.5s 0.3s infinite alternate ease-in-out;\n}\n\n@keyframes flashing-average {\n  0% {color: #470202; letter-spacing: -0.1em; font-size: 40px;}\n  100% {color: red; letter-spacing: 0.25em; font-size: 13px;}\n}\n\n@keyframes progress-filled-intro {\n  0% {transform: rotate(0);}\n  25% {transform: rotate(30deg);}\n  75% {transform: rotate(-30deg);}\n  100% {transform: rotate(0);}\n}\n\n@keyframes progress-filled-shake {\n  0% {height: 15px; transform: rotate(0);}\n  15% {height: 17px; transform: rotate(3deg);}\n  30% {transform: rotate(-3deg);}\n  50% {height: 14px;transform: rotate(0);}\n  80% {height: 20px; transform: rotate(3deg);}\n  100% {height: 15px; transform: rotate(-3deg);}\n}\n\n@keyframes progress-intro {\n  0% {width: 30%; left: -100px; top: 10%; transform: rotate(0);}\n  30% {left: 100px; top: 0;}\n  60% {left: 0; top: 80%;}\n  90% {width: 25%; left: 70%; top: -10px; transform: rotate(360deg);}\n  100% {width: 30%; left: 0; top: 0; transform: rotate(360deg);}\n}\n\n@keyframes progress-idle {\n  0% {top: 0; transform: rotate(0);}\n  30% {top: 15px; transform: rotate(3deg);}\n  60% {top: 5px;transform: rotate(-3deg);}\n  100% {top: 0;transform: rotate(0);}\n}\n\n@keyframes holds-intro {\n  0% {top: -100px}\n  60% {top: 100%}\n  100% {top: 0}\n}\n\n@keyframes holds-idle {\n  0% {top: 0}\n  60% {top: 50px}\n  100% {top: -50px}\n}\n\n@keyframes records-intro {\n  0% {top: 100%}\n  100% {top: 0}\n}\n\n@keyframes records-items {\n  0% {left: -1em}\n  100% {left: 1em}\n}\n\n\n/* Registration */\n.appointments {\n  width: 30%;\n  height: 30%;\n  padding: 1em;\n  left: 0;\n  background-color: white;\n  animation: registration-wait 15s 1, registration-intro 15s 3s 1 ease-out;\n}\n\n.appointments div {\n  width: 100%;\n  overflow: auto;\n  height: 70%;\n  box-sizing: border-box;\n}\n\n.appointments table {\n  width: 1000px;\n  margin: 1em;\n}\n\n.appointment-page{\n  max-width: 800px;\n  margin: auto;\n  position: relative;\n}\n\n.section-box th {\n  border: 1px solid rgb(212, 212, 212);\n  padding: 1em;\n  line-height: 2em;\n  background-color: #EEE;\n  font-weight: 500;\n}\n\n.section-box table td {\n  padding: 1em;\n  border: 1px solid rgb(212, 212, 212);\n  text-align: center;\n}\n\n\n@keyframes registration-intro {\n  0% {opacity: 0; top: 100%; touch-action: none; pointer-events: none;}\n  100% {opacity: 100%; top: 0; touch-action: auto; pointer-events: auto;}\n}\n\n@keyframes registration-wait {\n  0% {opacity: 0;}\n  100% {opacity: 0;}\n}\n\n.schedule {\n  width: 30%;\n  padding: 1em;\n  left: calc(30% + 2.5em);\n  background-color: white;\n  animation: registration-intro 10s 1 ease-out;\n}\n\n.schedule ion-icon {\n  vertical-align: bottom;\n  font-size: 1.25em;\n}\n\n.schedule p.met span.not-met {\n  display: none;\n} \n\n.schedule p.not-met span.met {\n  display: none;\n} \n\nspan.not-met ion-icon {\n  color: red;\n}\n\nspan.met ion-icon {\n  color: green;\n}\n\n.reg-links {\n  animation: registration-wait 15s 1, registration-intro 15s 3s 1 ease-out;\n}\n\ndialog {\n  padding: 0;\n  margin-top: 12vh;\n  max-width: 1024px;\n  min-width: 640px;\n  border: none;\n  border-radius: 1em;\n  overflow: unset;\n  h1 {\n    border-bottom: 1px solid #dfe2e6;\n    padding: 1.2em 2em;\n    margin: 0;\n    width: 100%;\n    box-sizing: border-box;\n\n    color: rgb(51, 51, 51);\n    font-size: 1.1em;\n  }\n  ul {\n    list-style: none;\n    padding: 0 2em;\n  }\n  label {\n    margin-right: 1em;\n    color: #494949;\n    font-size: 0.9em;\n    font-weight: 600;\n  }\n  input[type=\"text\"] {\n    width: 246px;\n    height: 36px;\n    padding: 8px 8px 8px 12px;\n    box-sizing: border-box;\n    border: none;\n    background: none;\n  }\n  input:focus-visible {\n    border: none;\n  }\n}\n\n@keyframes angry {\n  0% {background-color: white;}\n  10% {background-color: red;}\n  100% {background-color: white;}\n}\n\n@keyframes shake {\n  0% {transform: rotate(0);}\n  25% {transform: rotate(10deg);}\n  75% {transform: rotate(-10deg);}\n  100% {transform: rotate(0);}\n}\n\n.options {\n  display: none;\n  width: 100%;\n  max-height: 50vh;\n  position: absolute;\n  left: -2px;\n  overflow: auto;\n  overflow-y: scroll;\n\n  background-color: white;\n  border: 2px solid #0875e1;\n  border-radius: 0 0 4px 4px;\n  border-top-width: 1px;\n  border-top-color: #a1aab3;\n}\n\n.annoying-selector:focus-within .options, .options:focus-within {\n  display: block;\n}\n.annoying-selector {\n  height: 100%;\n  display: inline-block;\n  width: fit-content;\n  position: relative;\n  border-radius: 4px;\n  border: 2px solid #0875e1;\n}\n\n.annoying-selector ul {\n  padding: 0;\n  width: 100%;\n}\n\n.date-options li {\n  width: 100%;\n}\n\nul.selected-list {\n  padding: 0.35em;\n}\n\n.selected-list li {\n  width: fit-content;\n  display: inline;\n  margin-right: 0.25em;\n  padding: 0.1em;\n  font-size: 0.8em;\n  color: rgb(51, 51, 51);\n  background-color: rgb(232, 235, 237);\n}\n\n.annoying-selector button {\n\n  padding: 8px 8px 8px 12px;\n  box-sizing: border-box;\n  width: 100%;\n  background: none;\n  border:none;\n  color: rgb(73, 73, 73);\n  text-align: left;\n}\n\n.annoying-selector ul button:hover {\n  background-color: rgb(230, 235, 237);\n  cursor: pointer;\n}\n\n.annoying-selector ul button:hover > * {\n  cursor: pointer;\n}\n\n.annoying-selector button.options-header {\n  font-weight: 600;\n  font-size: 0.9em;\n  border-bottom: 1px solid #a1aab3;\n}\n\nbutton:hover {\n  cursor: pointer;\n}\n\n.stupid-fucking-modal--buttons {\n  margin-top: 5em;\n  padding: 0.5em 1.5em;\n  border-top: 1px solid #dfe2e6;\n  display: flex;\n  justify-content: right;\n}\n\n.stupid-fucking-modal--buttons button {\n  margin: 0.5em;\n  border: none;\n  border-radius: 2em;\n  padding: 1em 0;\n  width: 110px;\n  text-align: center;\n  color: white;\n  font-weight: 600;\n}\n.stupid-fucking-modal--buttons button.ok {\n  background-color: orange;\n  color: white;\n}\n.stupid-fucking-modal--buttons button.ok:hover {\n  background-color: hsla(34, 100%, 47.5%, 1);\n}\n\n.stupid-fucking-modal--buttons button.cancel {\n  color: hsla(0, 0%, 20%, 1);\n  background: none;\n  border: 1px solid;\n}\n.stupid-fucking-modal--buttons button.cancel:hover {\n  color: white;\n  background-color: hsla(0, 0%, 20%, 1);\n}\n\n.info-bar {\n  background-color: white;\n  font-size: 13px;\n  padding: 0 3em 3em 3em;\n}\n\n.info-segment-idk {\n  display: flex;\n  margin: 1em 0;\n}\n\n.info-segment-idk label {\n  color: #494949;\n  font-size: 1em;\n  font-weight: 600;\n}\n\n.info-segment-idk ul {\n  display: inline-block;\n  margin: 0;\n  list-style: none;\n  padding-left: 1.5em;\n}\n\n.info-segment-idk ul li {\n  width: fit-content;\n  margin-bottom: 0.5em;\n}\n\n.terrible-spreadsheet-mf {\n  margin: 2em 0;\n  display: flex;\n}\n\n.terrible-spreadsheet-mf .filters {\n  padding: 1em 2.5em;\n  background-color: white;\n  box-sizing: border-box;\n  width: 300px;\n  flex-shrink: 0;\n  flex-grow: 0;\n  height: fit-content;\n  position: sticky;\n  top: 3em;\n}\n\n.filters .credit {\n  margin-top: 2em;\n  font-size: 0.75em;\n  font-style: italic;\n}\n\n.filters .credit a {\n  color: #464646;\n}\n\n.filters button {\n  background: none;\n  border: none;\n  display: block;\n  margin: 1em 0;\n  text-align: left;\n  font-size: 0.8em;\n  color: #464646;\n}\n\n.filters button:hover {\n  color: black;\n}\n\n.filters h2 {\n  color: #333;\n  font-weight: 700;\n  margin: 1em 0;\n  font-size: 1.1em;\n}\n\n.terrible-spreadsheet-mf .results {\n  margin: 0 2.5em;\n  flex-grow: 1;\n  min-height: 60vh;\n  position: relative;\n  padding: 1em 0;\n}\n\n.terrible-spreadsheet-mf .results h2 {\n  margin-bottom: 1em;\n}\n\n.terrible-spreadsheet-mf .results ul {\n  padding: 0;\n  position: relative;\n}\n\n.edge {\n  width: 5px;\n  aspect-ratio: 1;\n  position: absolute;\n  background-color: red;\n}\n\n.origin {\n  width: 5px;\n  aspect-ratio: 1;\n  position: absolute;\n  background-color: lime;\n  z-index: 10;\n}\n\n.ease-in .comics {\n  transition-duration: 2s;\n}\n\n.comics > img {\n  height: 200px;\n}\n\n.comics > div {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-weight: 600;\n  color: black;\n  font-size: 2em;\n  filter: drop-shadow(0 -1px 5px white)\n}\n\n.comics {\n  padding: 0;\n  border-radius: 0;\n  border: none;\n}\n\n.animating .comics {\n  position: absolute;\n}\n\n.animating .comics > img {\n  height: auto;\n}\n\n.sky {\n  height: 70vh;\n  max-width: 100%;\n  margin: 2em;\n  position: relative;\n  cursor: crosshair;\n  overflow-x: clip;\n  overflow-y: hidden;\n}\n\n.courseBox {\n  margin: 1em auto;\n  transition-duration: 0.1s;\n  padding: 1em;\n  max-width: 300px;\n  font-family: roboto;\n  background-color: white;\n  box-shadow: 5px 5px 35px black;\n  border-radius: 1em;\n\n  -webkit-user-select: none; /* Safari */\n  -ms-user-select: none; /* IE 10 and IE 11 */\n  user-select: none; /* Standard syntax */\n}\n\n.movin-now .courseBox {\n  position: absolute;\n  margin: 0;\n}\n\n.courseBox * {\n  margin: 0;\n}\n\n.projectile {\n  position: absolute;\n  left: 50%;\n  bottom: 0;\n  width: 25vw;\n  transform: translateX(-50%);\n  animation: throw 0.75s 1;\n  opacity: 0;\n\n  -webkit-user-select: none; /* Safari */\n  -ms-user-select: none; /* IE 10 and IE 11 */\n  user-select: none; /* Standard syntax */\n}\n\n@keyframes throw {\n  0% {width: 25vw; opacity: 1;}\n  100% {width: 0px; opacity: 1;}\n}\n\n.clock {\n  margin: 1em 2em;\n  width: 230px;\n  height: 300px;\n  background-image: url('/public/bareclock.jpg');\n  background-size: cover;\n}\n\n.clock .hands {\n  height: 66px;\n  filter: drop-shadow(0px 3px 5px #000000aa);\n  top: 62px;\n  position: relative;\n  aspect-ratio: 1;\n  left: 72px;\n}\n\n.clock .seconds, .clock .minutes, .clock .hours{\n  width: 45%;\n  height: 5px;\n  left: calc(50% - 10px);\n  top: 50%;\n  position: absolute;\n  border-radius: 5px;\n\n  transition-duration: 0.25s;\n  background: #16283f;\n  transform: rotate(-90deg);\n  transform-origin: 10px;\n}\n\n.clock .seconds {\n  width: 45%;\n}\n\n.clock .hours {\n  width: 40%;\n}\n\n#select-course-modal {\n  max-width: 90vw;\n  width: 650px;\n  max-height: 80%;\n  overflow: auto;\n}\n\n#select-course-modal .flex {\n  margin: 1em;\n  display: flex;\n}\n\n#select-course-modal ul {\n  padding: 0;\n}\n\n#select-course-modal h2 {\n  margin-bottom: 1em;\n}\n\n#select-course-modal ul li {\n  margin-bottom: 1em;\n  color: #5b6166;\n}\n\n#select-course-modal ul li.active {\n  color: black;\n  font-weight: 600;\n}\n\n#select-course-modal .flex .left {\n  text-align: center;\n}\n\n#select-course-modal .flex .right {\n  margin-right: 1em;\n}\n\n.dayOfWeek {\n  margin: 0;\n  font-weight: 600;\n} \n\n.clock-container .instruction {\n  user-select: none;\n}\n#select-course-modal .stupid-fucking-modal--buttons {\n  margin-top: 1em;\n}\n\n.stupid-fucking-modal--buttons .ok.inactive, .stupid-fucking-modal--buttons .ok.inactive:hover {\n  cursor: auto;\n  background-color: rgb(205, 205, 205);\n}\n\n.mascot {\n  --scale: 150px;\n  position: fixed;\n  width: var(--scale);\n  filter: drop-shadow(0 0 10px #00000052);\n  bottom: 1em;\n  left: 1em;\n  z-index: 500;\n  transition-duration: 0.5s;\n}\n\n.mascot img {\n  width: 100%;\n  height: auto;\n}\n\n.mascot .speechBubble {\n  display: none;\n  background-color: white;\n  width: max-content;\n  max-width: 100%;\n  padding: 1em;\n  border-radius: 1.5em 1.5em 1.5em 0;\n  position: absolute;\n  bottom: 100%;\n  left: calc(100% - 2em);\n  font-size: calc(var(--scale) / 10);\n}\n\n.mascot.speaking {\n  --scale: 200px;\n}\n\n.mascot.speaking .speechBubble {\n  display: block;\n}\n\nnav.nav {\n  display: flex;\n  .left, .right {\n    display: flex;\n  }\n  .why-tf-are-you-reading-this {\n    flex-grow: 1;\n  }\n  .searcharea {\n    position: relative;\n    max-width: 526px;\n    margin: 0 auto;\n    padding: 0.5em;\n  }\n  .searchdropdown {\n    display: none;\n  }\n  .searcharea:focus-within .searchdropdown, .searchdropdown:hover {\n    display: block;\n    position: absolute;\n    background: white;\n    padding: 1.5em;\n    padding-top: calc(64px + 1em);\n    left: 0;\n    right: 0;\n    top: 0;\n    border-radius: 1em;\n    box-shadow: 0px 8px 16px 0 rgba(0, 0, 0, 0.12);\n    color: rgb(94, 106, 117);\n    font-weight: 600;\n    font-size: 0.9em;\n  }\n  .dysfunctionalSearch {\n    position: relative;\n    display: flex;\n    margin: 0 auto;\n    max-width: 526px;\n    border-radius: 2em;\n    background-color: rgb(240, 241, 242);\n    border: 1px solid rgb(206, 211, 217);\n    color: rgb(51, 51, 51);\n    z-index: 10;\n  }\n  .dysfunctionalSearch input {\n    margin: 0.6em;\n    max-width: none;\n    width: 100%;\n    border: none;\n    background: none;\n    outline: none;\n    line-height: 1.5em;\n    font-size: 1em;\n    font-weight: 600;\n    font-family: roboto;\n  }\n  .dysfunctionalSearch ion-icon {\n    margin: auto 0;\n    width: 1em;\n    padding-left: 0.75em;\n    \n    font-size: 1.5em;\n  }\n  a, button {\n    background: none;\n    padding: 1em;\n    border-radius: 0;\n    border: none;\n    \n    font-weight: 700;\n    font-size: 0.85em;\n    color: #333d47;\n    text-decoration: none;    \n    text-transform: uppercase;\n\n    font-family: roboto;\n  }\n  a.humour-link img {\n    width: 2em;\n    vertical-align: middle;\n  }\n  a.humour-link, button {\n    border-right: 1px solid #cad4d9;\n    transition: background-color 0.5s;\n  }\n  a.humour-link:hover, button:hover {\n    background-color: #e8ebed;\n  }\n  .home-link {padding: 1.5em; padding-right: 0;}\n  button ion-icon {\n    font-size: 2em;\n    vertical-align: middle;\n    padding-bottom: 0.1em;\n    padding-inline: 0.1em;\n  }\n  .right * {\n    margin: 1em;\n  }\n  .right {\n    margin-right: 0.5em;\n    padding-left: 100px;\n  }\n  .hotphoto {\n    border-radius: 100%;\n    aspect-ratio: 1;\n    height: 32px;\n  }\n}\n::-ms-input-placeholder, ::placeholder {\n  color:#959596;\n} \n\n::placeholder {\n  color:#959596;\n  opacity: 1; /* Firefox */\n} \n\n.register-button {\n  float: right;\n  border-radius: 1em;\n  padding: 0.25em 2em;\n  border: 1px solid;\n  background: none;\n}\n\n.register-button.inactive {\n  color: grey;\n  cursor: default;\n}\n\nspan.pointer {\n  position: absolute;\n  animation: point 1s infinite ease-in-out;  \n  transform: translateX(0);\n  margin-left: 0.25em;\n}\n\n@keyframes point {\n  0% {transform: translateX(0);}\n  66% {transform: translateX(50%);}\n  100% {transform: translateX(0);}\n}\n\n.captcha-check {\n  position: relative;\n  width: fit-content;\n  margin: 1em 0;\n  padding: 1em 0.5em;\n  background: #f9f9f9;\n  border: 1px solid #dbdcdb;\n  border-radius: 3px;\n  float: right;\n  box-shadow: 0 2px 5px #0000000d;\n  label {\n    padding-inline: 0.5em;\n  }\n}\n\n.spinner {\n  display: none;\n  font-size: 1.5em;\n  position: absolute;\n  left: 0.5em;\n  color: #408def;\n  animation: spin 0.5s infinite ease-out;\n  top: 0.65em;\n  transform: translate(-50%, 0);\n}\n\n@keyframes spin {\n  0% {transform: rotate(0);}\n  100% {transform: rotate(360deg);}\n}\n#silly-captcha {\n  min-width: unset;\n  border-radius: 0;\n  margin-block: auto;\n  max-height: 80%;\n  overflow: auto;\n}\n.captcha-header {\n  margin: 0.5em;\n  padding: 1.5em 2em;\n  background-color: #408def;\n  color: white;\n  span {\n    display: block;\n    margin: 0.25em 0;\n    font-size: 1.5em;\n    font-weight: 700;\n  }\n}\n\n.captcha-box {\n  max-width: 446px;\n}\n.captcha-box table {\n  width: calc(100% - 1em);\n  margin: 0.5em;\n  display: flex;\n  flex-direction: column;\n  aspect-ratio: 1;\n}\n\n.captcha-box p.credit {\n  margin: 1em;\n  font-style: italic;\n  font-size: 0.6em;\n  margin-bottom: 0;\n}\n\n.correct .captcha-box table td, .correct .captcha-bottom button {\n  background-color: #38ce64;\n}\n\n.correct .captcha-box table td {\n  border-color: #38ce64;\n}\n\n.wrong .captcha-box table td, .wrong .captcha-bottom button {\n  background-color: #ef4040;\n}\n\n.wrong .captcha-box table td {\n  border-color: #ef4040;\n}\n\n\n.wrong .captcha-bottom button {\n  transition-duration: 0.1s;\n  animation: 0.1s shake infinite;\n}\n\n.wrong .captcha-bottom button .wrong, .correct .captcha-bottom button .correct {\n  display: block;\n}\n\n.wrong .captcha-bottom button .state, .correct .captcha-bottom button .state {\n  display: none;\n}\n\n.captcha-box table td {\n  border: 1px solid rgb(212, 212, 212);\n  padding: 0;\n  text-align: center;\n  background-color: #408def;\n  box-sizing: border-box;\n  flex-grow: 1;\n}\n.captcha-box table tr {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n}\n\n.captcha-box table td.selected button {\n  width: calc(100% - 2em);\n  height: calc(100% - 2em);\n  top: 1em;\n}\n.captcha-box table td button {\n  border: none;\n  background: white;\n  \n  padding: 1em;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n  font-weight: 600;\n  color: #333;\n  position: relative;\n  transition-duration: 0.75s;\n}\n\n.captcha-box table td button mark {\n  background-color: rgba(255, 255, 255, 0.8);\n  color: #333;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.captcha-bottom {\n  display: flex;\n  justify-content: space-between;\n  font-weight: 600;\n}\n\n.captcha-bottom p {\n  margin: 0.5em;\n  padding: 0.5em 1em;\n}\n\n.captcha-bottom button .wrong, .captcha-bottom button .correct {\n  display: none;\n}\n\n.bold {\n  font-weight: 800;\n}\n\n.bold .hideonbold {\n  display: none;\n}\n\n.captcha-bottom button {\n  background-color: #408def;\n  margin: 0.5em;\n  padding: 0.5em 1em;\n  border-radius: 3px;\n  border: none;\n\n  color: white;\n  font-weight: 600;\n}\n\n.timetable {\n  width: 1000px;\n  max-width: 100%;\n  overflow: clip;\n  position: relative;\n  height: 500px;\n  margin: auto;\n  border-radius: 1em;\n  filter: drop-shadow(0 2px 5px #00000036);\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n}\n\n.timetable p {\n  user-select: none;\n}\n\n.courseCard {\n  background-color: #e6ebed;\n  padding: 0.5em;\n  border-radius: 0.5em;\n}\n\n.timetable svg {\n  margin: 1em auto;\n}\n.timetable path {\n  fill: transparent;\n}\n.timetable text {\n  font-size: 2.84em;\n  font-weight: 900;\n  fill: #f29110;\n}\n\n.ezekiel {\n  left: 0;\n  right: 0;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n}\n\n.surrounding {\n  min-width: 1000px;\n  height: auto;\n}\n\n.confetti {\n  width: 50px;\n  height: 10px;\n  background-color: red;\n  \n  z-index: 500;\n}\n\n.confetti.blue {\n  background-color: #005CB9;\n}\n\n.confetti.gold {\n  background-color: #F38B00;\n}\n\n.confetti.white {\n  background-color: white;\n}\n\n\n#confettitwall {\n  position: fixed;\n  top: 64px;\n}\n\n.hooray footer a {\n  z-index: 600;\n  position: relative;\n}\n\n.timetable p {\n  margin-inline: 1em;\n  margin-bottom: 1em;\n  z-index: 10;\n}\n\n.timetable a {\n  color: #0071c9;\n  text-decoration: none;\n  border-bottom: 1px solid;\n}\n\n.jerkday {\n  font-size: 2em;\n  font-weight: 600;\n  color: purple;\n}\n\n.workedtheday {\n  width: 500px;\n}\n\n.me {\n  width: 600px;\n}\n\n.finances {\n  display: flex;\n  gap: 1em;\n  flex-wrap: wrap;\n}\n.finances .section-box {\n  position: relative;\n  height: fit-content;\n  min-height: 0;\n}\n\n.finances .section-box h2, .finances .section-box a {\n  font-weight: 400;\n  color: #393939;\n  text-decoration: none;\n}\n.finances .section-box h2 {\n  margin: 0.5em;\n}\n\n.finances .section-box a:hover {\n  text-decoration: underline;\n}\n\n.nowrap {\n  white-space: nowrap;\n}\n\n@media only screen and (min-width: 600px) {\n  .only-mobile {\n    display: none;\n  }\n  .only-desktop {\n    display: block;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .only-mobile {\n    display: block;\n  }\n  .only-desktop {\n    display: none;\n  }\n  .mascot {\n    width: calc(var(--scale) / 2);\n    bottom: 3em;\n  }\n  .mascot .speechBubble {\n    left: 1em;\n    max-width: 200%;\n  }\n  .home {\n    flex-direction: column;\n    flex-flow: column-reverse;\n  }\n  .home .left, .home .right {\n    margin:0;\n    width: 100%;\n  }\n  nav.nav .right {\n    padding-left: 0;\n  }\n  .hide-on-mobile {\n    display: none;\n  }\n  .section-container {\n    margin-inline: 1em;\n    height: auto;\n  }\n  .appointments, .appointment-page {\n    transform: none;\n    overflow: auto;\n  }\n  .section-box {\n    margin-block: 2em;\n    position: relative;\n    left: 0;\n    width: calc(100% - 2em) !important;\n  }\n  .register-button {\n    float: none;\n  }\n  .holds {\n    margin-block: 3em;\n  }\n  .links {\n    width: 100%;\n    left: 0.5em;\n    position: relative;\n  }\n  dialog {\n    max-width: calc(100% - 2em);\n    min-width: 0;\n    margin-inline: 1em;\n  }\n  .terrible-spreadsheet-mf {\n    flex-direction: column;\n  }\n  .terrible-spreadsheet-mf .filters {\n    position: static;\n    width: 100%;\n  }\n  .comics > img {\n    max-width: 100%;\n    width: 100%;\n    height: auto;\n  }\n  #select-course-modal .flex {\n    flex-direction: column;\n  }\n  .clock {\n    margin-inline: auto;\n    height: 200px;\n  }\n  nav.nav .dysfunctionalSearch {\n    background: none;\n    border: none;\n    justify-content: right;\n  }\n  nav.nav .dysfunctionalSearch ion-icon {\n    position: absolute;\n    top: 0.5em;\n  }\n  nav.nav .dysfunctionalSearch input {\n    width: 2em;\n    opacity: 0;\n  }\n  input[type=\"text\"] {\n    font-size: 16px;\n  }\n  .annoying-selector .options {\n    display: block;\n  }\n  .annoying-selector {\n    width: 100%;\n    height: 200px;\n  }\n  .annoying-selector input[type=\"text\"] {\n    display: none;\n  }\n  .options {\n    max-height: 200px;\n  }\n  #stupid-fucking-modal {\n    width: 100%;\n  }\n  .finalheader {\n    font-size: 0.75em;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
